import React, { memo } from "react";
import { Badge } from "react-bootstrap";
const ExperienceCard = (props) => {
  return (
    <div className="single round-border p-4 mb-3">
      <ul className="ps-4">
        {props.data.detail.map((itemd, indexd) => {
          // Check if the item is an object (which would contain nested items)
          if (typeof itemd === "object") {
            // Iterate over the keys (e.g., Google Cloud APIs, Microsoft Azure SDK)
            return Object.keys(itemd).map((key, indexKey) => (
              <li key={indexd + "-" + indexKey} className="body-text">
                {key}:
                <ul>
                  {itemd[key].map((child, indexChild) => (
                    <li key={indexChild} className="body-text">
                      {child}
                    </li>
                  ))}
                </ul>
              </li>
            ));
          }
          return (
            <li key={indexd} className="body-text">
              {itemd}
            </li>
          );
        })}
      </ul>

      <div>
        {props.data.technology.map((itemt, indext) => (
          <Badge key={indext} pill bg="dark" className="me-2">
            {itemt}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default memo(ExperienceCard);
